module.exports = __webpack_public_path__ + "img/e_2_17_g.ffc23766.png";